import React from 'react';
import _ from 'lodash';
import { Table, Tooltip } from 'antd';

function sum(arr) {
    if (!arr || arr.length === 0) return ''
    if (arr.every(e => isEmpty(e))) {
        return ''
    }
    const total = arr.filter(e => !!e).reduce((prev, curr, idx, arr) => prev + (curr || 0), 0);
    return total.toFixed && total.toFixed(2)
}

const isEmpty = (val) => {
    return val === undefined || val === null;
}
class AmountItemsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    lossAmountsExprFormat(lossAmountItems = []) {
        return lossAmountItems.map(({ amountItem = {}, claimPercent, lossAmount, claimAmount, trafficInsuranceAmount }) => {
            let fmt = '';
            const { itemName = '未知' } = amountItem;
            if (isEmpty(lossAmount)) return fmt;
            if (!claimPercent) return `${itemName}${claimAmount.toFixed(2)}`;
            if (trafficInsuranceAmount) {
                fmt += `${itemName}（${lossAmount.toFixed(2)}-${trafficInsuranceAmount.toFixed(2)}）`;
            } else {
                fmt += `${itemName}${lossAmount}`;
            }
            if (claimPercent) {
                fmt += `*${claimPercent}%`
            }
            return fmt;
        }).filter(v => !!v).join('+');

    }
    // 计算合计项
    totalize = () => {
        const claimResps = _.cloneDeep(this.props.claimResps || []);
        const dataSource = _.flatten(claimResps.map((resp = {}, respIndex) => {
            let rowCount = 0;
            const { amountItems = [], claimResp = {} } = resp;
            rowCount = rowCount + amountItems.length
            return amountItems.map((item = {}, itemIndex) => {
                return {
                    'claimRespName': claimResp.claimRespName || '',
                    'amountName': item.amountItem && item.amountItem.itemName || '',
                    'exprDataFmt': item.formula && item.formula.exprDataFmt || '',
                    'lossAmount': !isEmpty(item.lossAmount) ? item.lossAmount.toFixed(2) : '',
                    'claimPercent': !isEmpty(item.claimPercent) ? item.claimPercent : '',
                    'claimAmount': !isEmpty(item.claimAmount) ? item.claimAmount.toFixed(2) : '',
                    trafficInsuranceAmount: !isEmpty(item.trafficInsuranceAmount) ? item.trafficInsuranceAmount.toFixed(2) : '',
                    'remark': item.remark || '',
                    // 用于单元格列合并
                    rowSpan: itemIndex === 0 ? rowCount : 0,
                };
            })
        }))
        let newStatistics = {
            key: 'total',
            'claimRespName': '合计',
            rowSpan: 1,
        };
        if (dataSource.length) {
            const totalData = {};
            const lossAmountItems = _.flatten(claimResps.map(({ amountItems = [] }) => amountItems)) || [];
            totalData['claimAmount'] = sum(_.flatten(lossAmountItems.map(({ claimAmount }) => claimAmount)));
            const isShowLossAmount = lossAmountItems.every(data => !isEmpty(data.claimAmount));
            totalData['lossAmount'] = isShowLossAmount ? (this.lossAmountsExprFormat(lossAmountItems) + `=${totalData['claimAmount'] || 0}`) : '';
            newStatistics = Object.assign(newStatistics, totalData)
        }
        return [
            ...dataSource,
            newStatistics,
        ]
    }

    render() {
        let columns;
        columns = [
            {
                title: '保障责任',
                dataIndex: 'claimRespName',
                key: 'claimRespName',
                render: (value, row) => {

                    return {
                        children: value,
                        props: {
                            rowSpan: row.rowSpan,
                        },
                    }
                }
            },
            {
                title: '费用项',
                dataIndex: 'amountName',
                key: 'amountName',
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };

                    if (index === row.length - 1) {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            },
            // {
            //     title: '损失计算等式',
            //     dataIndex: 'exprDataFmt',
            //     key: 'exprDataFmt',
            // },
            {
                title: '损失金额',
                dataIndex: 'lossAmount',
                key: 'lossAmount',
            },
            {
                title: '扣除交强险金额',
                dataIndex: 'trafficInsuranceAmount',
                key: 'trafficInsuranceAmount',

            },
            {
                title: '赔付比例%',
                dataIndex: 'claimPercent',
                key: 'claimPercent',
            },
            {
                title: '赔偿金额',
                dataIndex: 'claimAmount',
                key: 'claimAmount',
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                render: (value, row) => {

                    return {
                        children: <Tooltip placement="topLeft" title={value}>
                            <span>{value && value.substring(0, 8)}{value && value.length > 8 && '...'}</span>
                        </Tooltip>,
                    }
                }
            },
        ];
        if (this.props.source && this.props.source === 'StarChaseReportDetailFoot') {

            columns = [
                {
                    title: '保障责任',
                    dataIndex: 'claimRespName',
                    key: 'claimRespName',
                    render: (value, row) => {

                        return {
                            children: value,
                            props: {
                                rowSpan: row.rowSpan,
                            },
                        }
                    }
                },
                {
                    title: '费用项',
                    dataIndex: 'amountName',
                    key: 'amountName',
                    render: (value, row, index) => {
                        const obj = {
                            children: value,
                            props: {},
                        };

                        if (index === row.length - 1) {
                            obj.props.colSpan = 0;
                        }
                        return obj;
                    }
                },
                // {
                //     title: '损失计算等式',
                //     dataIndex: 'exprDataFmt',
                //     key: 'exprDataFmt',
                // },
                {
                    title: '损失金额',
                    dataIndex: 'lossAmount',
                    key: 'lossAmount',
                },

                {
                    title: '赔付比例%',
                    dataIndex: 'claimPercent',
                    key: 'claimPercent',
                },
                {
                    title: '赔偿金额',
                    dataIndex: 'claimAmount',
                    key: 'claimAmount',
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    render: (value, row) => {

                        return {
                            children: <Tooltip placement="topLeft" title={value}>
                                <span>{value && value.substring(0, 8)}{value && value.length > 8 && '...'}</span>
                            </Tooltip>,
                        }
                    }
                },
            ];
        }

        return (
            <div className='bill-table'>
                <h3 style={{ marginTop: 10, marginBottom: 10, fontSize: 12, fontWeight: 'bold' }}>赔付项目</h3>
                <Table
                    size='small'
                    bordered
                    dataSource={this.totalize()}
                    columns={columns}
                    pagination={false}
                />

            </div>
        );
    }
}

export default AmountItemsTable